// oc/components/scroll-to-top.tsx
import React, { ReactElement, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  children: ReactElement; // felülírjuk az FC default children: ReactNode típusát
}

export const OcScrollToTop: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // React.FC esetén a visszatípus automatikusan ReactElement | null lesz
  return children;
};

export default OcScrollToTop;
